// Afficher l'indicateur de chargement pendant le démarrage de React.
// Si JavaScript échoue, réafficher le contenu après huit secondes au maximum.
(function () {
  var root = document.getElementById("root");
  var loader = document.getElementById("app-loading");
  // L'accueil est déjà visible : l'hydratation ajoute les interactions sans le masquer.
  var homePath = /^\/(?:en\/?)?$/.test(window.location.pathname);
  var language = /^\/en(?:\/|$)/.test(window.location.pathname) ? "en" : "fr";
  if (root.dataset.rendered === "react" && homePath && document.documentElement.lang === language) {
    loader.remove();
    return;
  }
  // Certains serveurs d'aperçu renvoient l'accueil comme secours d'une autre route.
  delete root.dataset.rendered;
  // La langue suit l'URL, y compris sur les routes sans HTML prérendu dédié.
  if (/^\/en(?:\/|$)/.test(window.location.pathname)) {
    loader.setAttribute("aria-label", "Loading website");
    loader.querySelector("p").textContent = "Loading…";
  }
  document.documentElement.classList.add("app-loading");
  root.setAttribute("aria-busy", "true");
  var timeout,
    frame,
    lastTime = null,
    phase = 0.4;
  var motion = window.matchMedia("(prefers-reduced-motion: reduce)");
  var strands = loader.querySelectorAll("[data-strand]");
  var rungs = [],
    nodes = [],
    colors = ["#304f8c", "#39bcea"];
  function element(tag, parent) {
    var node = document.createElementNS("http://www.w3.org/2000/svg", tag);
    loader.querySelector(parent).appendChild(node);
    return node;
  }
  for (var row = 0; row < 11; row++) {
    rungs.push(element("line", "[data-rungs]"));
    nodes.push([
      element("circle", "[data-nodes]"),
      element("circle", "[data-nodes]"),
    ]);
  }
  // Deux brins opposés : la taille et l'opacité des points suggèrent la profondeur.
  function position(y, strand) {
    var angle = ((y - 8) / 88) * Math.PI * 2 + phase + strand * Math.PI;
    return { x: 32 + Math.sin(angle) * 18, depth: (Math.cos(angle) + 1) / 2 };
  }
  function draw() {
    strands.forEach(function (path, strand) {
      var d = "";
      for (var y = 8; y <= 96; y++)
        d += (y === 8 ? "M" : "L") + position(y, strand).x.toFixed(2) + " " + y;
      path.setAttribute("d", d);
    });
    rungs.forEach(function (line, row) {
      var y = 8 + row * 8.8,
        a = position(y, 0),
        b = position(y, 1);
      var light = Math.pow((Math.sin(phase * 2 - row * 0.55) + 1) / 2, 5);
      line.setAttribute("x1", a.x);
      line.setAttribute("x2", b.x);
      line.setAttribute("y1", y);
      line.setAttribute("y2", y);
      line.setAttribute("opacity", 0.45 + light * 0.55);
      nodes[row].forEach(function (node, strand) {
        var point = strand === 0 ? a : b;
        node.setAttribute("cx", point.x);
        node.setAttribute("cy", y);
        node.setAttribute("r", 2 + point.depth * 1.05 + light * 0.65);
        node.setAttribute(
          "fill",
          light > 0.6 ? (strand === 0 ? "#4776c4" : "#20c9e8") : colors[strand],
        );
        node.setAttribute(
          "opacity",
          Math.min(1, 0.4 + point.depth * 0.5 + light * 0.4),
        );
      });
    });
  }
  function animate(time) {
    if (lastTime !== null)
      phase += (Math.min(time - lastTime, 50) / 3200) * Math.PI * 2;
    lastTime = time;
    draw();
    frame = requestAnimationFrame(animate);
  }
  function updateMotion() {
    cancelAnimationFrame(frame);
    lastTime = null;
    if (!motion.matches) frame = requestAnimationFrame(animate);
  }
  function finish() {
    clearTimeout(timeout);
    cancelAnimationFrame(frame);
    motion.removeEventListener("change", updateMotion);
    document.removeEventListener("nahibu:ready", finish);
    document.documentElement.classList.remove("app-loading");
    root.removeAttribute("aria-busy");
    loader.remove();
  }
  document.addEventListener("nahibu:ready", finish);
  timeout = setTimeout(finish, 8000);
  draw();
  motion.addEventListener("change", updateMotion);
  updateMotion();
})();
